export const COOKIE_CONSENT_KEY = "pinpadel.cookies";
export const OPEN_COOKIE_BANNER_EVENT = "pinpadel:open-cookies";

export type CookieChoice = "all" | "essential";

export type CookieConsent = {
  choice: CookieChoice;
  updatedAt: string;
};

const isChoice = (value: unknown): value is CookieChoice =>
  value === "all" || value === "essential";

export const readCookieConsent = (): CookieConsent | null => {
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<CookieConsent>;
    if (!isChoice(parsed.choice)) return null;
    return {
      choice: parsed.choice,
      updatedAt: typeof parsed.updatedAt === "string" ? parsed.updatedAt : "",
    };
  } catch {
    return null;
  }
};

export const saveCookieConsent = (choice: CookieChoice): CookieConsent => {
  const consent: CookieConsent = {
    choice,
    updatedAt: new Date().toISOString(),
  };
  try {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(consent));
  } catch {
    // The choice still applies for this visit when storage is unavailable.
  }
  return consent;
};

export const openCookieSettings = () => {
  window.dispatchEvent(new Event(OPEN_COOKIE_BANNER_EVENT));
};
